(function () {
  if (window.__cartSubscriptionBound) return;
  window.__cartSubscriptionBound = true;

  function getWrapper(select) {
    return select.closest('.cart-subscription');
  }

  function setUpdating(select, isUpdating) {
    if (!select) return;
    var wrapper = getWrapper(select);
    select.disabled = isUpdating;
    if (wrapper) {
      wrapper.classList.toggle('is-updating', isUpdating);
    }
  }

  function getQuantity(select, item) {
    var qtyInput = item && item.querySelector('.quantity-input__input, input[name="updates[]"]');
    if (qtyInput && qtyInput.value) {
      var parsed = parseInt(qtyInput.value, 10);
      if (!isNaN(parsed) && parsed > 0) return parsed;
    }
    var fromAttr = parseInt(select.getAttribute('data-quantity') || '1', 10);
    return !isNaN(fromAttr) && fromAttr > 0 ? fromAttr : 1;
  }

  function currentPlanId(item) {
    if (!item || !item.selling_plan_allocation) return '';
    if (item.selling_plan_allocation.selling_plan_id) {
      return String(item.selling_plan_allocation.selling_plan_id);
    }
    if (item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) {
      return String(item.selling_plan_allocation.selling_plan.id);
    }
    return '';
  }

  function findCartItem(cart, key, variantId) {
    if (!cart || !cart.items) return { item: null, line: -1 };
    var index = cart.items.findIndex(function (entry) {
      return entry.key === key;
    });
    if (index === -1 && variantId) {
      index = cart.items.findIndex(function (entry) {
        return String(entry.variant_id) === String(variantId);
      });
    }
    return {
      item: index >= 0 ? cart.items[index] : null,
      line: index >= 0 ? index + 1 : -1
    };
  }

  function planMatches(item, sellingPlan) {
    return currentPlanId(item) === String(sellingPlan || '');
  }

  function readErrorMessage(data) {
    if (!data) return 'Unable to update subscription plan. Please try again.';
    return data.description || data.message || 'Unable to update subscription plan. Please try again.';
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response
        .text()
        .then(function (text) {
          var data = {};
          if (text) {
            try {
              data = JSON.parse(text);
            } catch (e) {
              data = { description: text };
            }
          }
          if (!response.ok) {
            throw new Error(readErrorMessage(data));
          }
          return data;
        });
    });
  }

  function cartHeaders() {
    return {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };
  }

  function cleanProperties(properties) {
    if (!properties) return {};
    var cleaned = {};
    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (value == null || value === '') return;
      if (typeof value === 'object') return;
      cleaned[key] = String(value);
    });
    return cleaned;
  }

  function changeSellingPlan(line, quantity, sellingPlan) {
    return fetchJson('/cart/change.js', {
      method: 'POST',
      credentials: 'include',
      headers: cartHeaders(),
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        selling_plan: parseInt(sellingPlan, 10)
      })
    });
  }

  function switchToOneTime(item) {
    var payload = {
      id: item.variant_id,
      quantity: item.quantity
    };
    var properties = cleanProperties(item.properties);
    if (Object.keys(properties).length) {
      payload.properties = properties;
    }

    return fetchJson('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: cartHeaders(),
      body: JSON.stringify(payload)
    }).then(function () {
      return fetchJson('/cart/change.js', {
        method: 'POST',
        credentials: 'include',
        headers: cartHeaders(),
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });
    });
  }

  function reinitFreeShippingBar(cart) {
    if (typeof window.updateFreeShippingBar === 'function') {
      window.updateFreeShippingBar(cart);
    }
  }

  function initSwiperFallback(selector, options) {
    if (typeof window.Swiper === 'undefined') return;
    document.querySelectorAll(selector).forEach(function (slider) {
      if (slider.swiper) return;
      if (!slider.querySelector('.swiper-slide')) return;
      try {
        new window.Swiper(slider, options);
      } catch (e) {}
    });
  }

  function reinitCartSliders() {
    document.dispatchEvent(new CustomEvent('cart:build'));

    if (typeof window.triggerAllSlidersRefresh === 'function') {
      window.triggerAllSlidersRefresh(true);
    }
    if (typeof window.reinitOfferSlider === 'function') {
      window.reinitOfferSlider();
    }
    if (typeof window.initOfferSlider === 'function') {
      window.initOfferSlider();
    }

    setTimeout(function () {
      initSwiperFallback('.cart-product-swiper', {
        spaceBetween: 10,
        slidesPerView: 2.2,
        watchOverflow: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.quick-cart .swiper-button-next',
          prevEl: '.quick-cart .swiper-button-prev'
        }
      });
      initSwiperFallback('.offer-slider', {
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: true,
        observer: true,
        observeParents: true
      });
      initSwiperFallback('[data-cross-sells-slider].swiper, .cross-sells__items.swiper', {
        slidesPerView: 1.15,
        spaceBetween: 8,
        watchOverflow: true,
        grabCursor: true,
        observer: true,
        observeParents: true
      });
    }, 120);
  }

  function reinitCartDrawerWidgets(cart) {
    reinitFreeShippingBar(cart);
    requestAnimationFrame(function () {
      reinitCartSliders();
    });
  }

  window.reinitCartDrawerWidgets = reinitCartDrawerWidgets;
  window.reinitFreeShippingBar = reinitFreeShippingBar;

  function refreshCartDrawer(cart) {
    var drawer = document.querySelector('.quick-cart__wrapper');
    if (!drawer) return Promise.resolve();

    var wasOpen = drawer.classList.contains('active');

    return fetch('/cart?section_id=quick-cart&t=' + Date.now(), { cache: 'no-store' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newWrapper = doc.querySelector('.quick-cart__wrapper');
        var liveDrawer = document.querySelector('.quick-cart__wrapper');
        if (!newWrapper || !liveDrawer) return;

        liveDrawer.innerHTML = newWrapper.innerHTML;
        if (wasOpen) liveDrawer.classList.add('active');

        if (typeof window.updateCartFooterAndShipping === 'function') {
          window.updateCartFooterAndShipping(doc);
        }

        reinitCartDrawerWidgets(cart);
      });
  }

  function refreshMainCart() {
    var cartSection = document.querySelector('[data-section-type="cart"]');
    if (!cartSection) return Promise.resolve();

    var sectionId = cartSection.getAttribute('data-section-id') || 'main-cart';

    return fetch('/cart?section_id=' + encodeURIComponent(sectionId) + '&t=' + Date.now(), { cache: 'no-store' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newSection = doc.querySelector('[data-section-type="cart"]');
        var liveSection = document.querySelector('[data-section-type="cart"]');
        if (newSection && liveSection) {
          liveSection.innerHTML = newSection.innerHTML;
        }
      });
  }

  function updateHeaderCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    document.querySelectorAll('[data-js-cart-count], .quick-cart__heading sup').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-cart-selling-plan]');
    if (!select || select.disabled) return;

    var itemEl = select.closest('[data-input-item]');
    var key = select.getAttribute('data-line-key') || (itemEl && itemEl.getAttribute('data-key'));
    var previous = select.getAttribute('data-current-plan') || '';
    var sellingPlan = select.value || '';
    var variantId = select.getAttribute('data-variant-id') || (itemEl && itemEl.getAttribute('data-id'));
    var quantity = getQuantity(select, itemEl);
    var hintedLine = parseInt(select.getAttribute('data-line') || '', 10);

    if (!key || sellingPlan === previous) return;

    var safetyTimer = setTimeout(function () {
      setUpdating(select, false);
    }, 8000);

    setUpdating(select, true);
    window.__cartSubscriptionUpdating = true;

    fetchJson('/cart.js?t=' + Date.now(), { cache: 'no-store', credentials: 'include' })
      .then(function (cart) {
        var match = findCartItem(cart, key, variantId);
        var line = match.line > 0 ? match.line : hintedLine;
        if (!line || line < 1 || !match.item) {
          throw new Error('Unable to find this item in the cart.');
        }
        if (!sellingPlan) {
          return switchToOneTime(match.item);
        }
        return changeSellingPlan(line, match.item.quantity || quantity, sellingPlan);
      })
      .then(function (updatedCart) {
        var match = findCartItem(updatedCart, key, variantId);
        if (match.item && !planMatches(match.item, sellingPlan)) {
          var fallback = updatedCart.items.find(function (entry) {
            return String(entry.variant_id) === String(variantId) && planMatches(entry, sellingPlan);
          });
          if (!fallback) {
            throw new Error('Subscription plan did not update. Please try again.');
          }
        }

        updateHeaderCount(updatedCart);

        if (typeof window.refreshQuickCartFull === 'function') {
          return window.refreshQuickCartFull().then(function () {
            return updatedCart;
          });
        }

        return Promise.all([refreshCartDrawer(updatedCart), refreshMainCart()]).then(function () {
          reinitCartDrawerWidgets(updatedCart);
          return updatedCart;
        });
      })
      .catch(function (error) {
        if (select.isConnected) {
          select.value = previous;
        }
        window.alert(error && error.message ? error.message : 'Unable to update subscription plan. Please try again.');
      })
      .then(function () {
        clearTimeout(safetyTimer);
        window.__cartSubscriptionUpdating = false;
        if (select.isConnected) {
          setUpdating(select, false);
        }
      });
  });
})();
